import { render } from "./Bac.vue?vue&type=template&id=1162bc65&scoped=true"
import script from "./Bac.vue?vue&type=script&lang=js"
export * from "./Bac.vue?vue&type=script&lang=js"

import "./Bac.vue?vue&type=style&index=0&id=1162bc65&scoped=true&lang=css"

import exportComponent from "E:\\项目\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1162bc65"]])

export default __exports__